export default "__VITE_PUBLIC_ASSET__7bf3b649__"